// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarAdvertise_wrapper__5sxbC","container":"SidebarAdvertise_container__tx3E7","description":"SidebarAdvertise_description__6E-2+","btn":"SidebarAdvertise_btn__AMunz"};